import { ClarityType } from '../clarityValue';
function listCV(values) {
    return { type: ClarityType.List, list: values };
}
export { listCV };
//# sourceMappingURL=listCV.js.map